import React from 'react';
import { Box, Typography } from '@mui/material';

const Dashboard: React.FC = () => (
  <Box sx={{ p: 3 }}>
    <Typography variant="h5">Dashboard</Typography>
    <Typography color="text.secondary">Coming soon</Typography>
  </Box>
);

export default Dashboard;
